// Test file for debugging breakpoints
export function debugTest() {
  // Set a breakpoint on this line
  console.log("Debug test function called");

  // And on this line
  const testVar = "This is a test";

  // And here
  return testVar;
}
